module.exports = __webpack_public_path__ + "static/media/ic_error_login.14570f06.svg";